<div class="lg:ml-0">
  <div
    class="h-[102px] align-center w-full bg-white border-b border-[#E6EFF5] flex items-center justify-between px-10 tablet:px-[12px] tablet:h-[76px]">
    @if (isMobile()) {
      <a class="text-center block w-1/3 max-w-48" href="" routerLink="/dashboard">
        <img alt="MyFirst logo" class="logo" src="/images/logo.svg"/>
      </a>
    }
    <h1 class="text-h1 tablet:text-[18px] text-content md:hidden">
      {{ title() }}
    </h1>
    <div class="flex items-center justify-end md:w-full h-[40px]">
      @if (isAuthenticated()) {
        <fc-language-switch class="mr-4" />
        @if (isMobile()) {
          <fc-menu-button class="mr-4" />
        }
        <fc-menu-user />
      }
    </div>
  </div>
</div>
